import React from 'react'
import './Ptop.css'

const Ptop = () => {
  return (
    <div className='P-top'>
        <div className='Pt-h'>
            <div className='Pt-h1'>Edit</div>
            <div className='Pt-h2'>Profile</div>
            <div className='Pt-h3'>Logout</div>
        </div>

    </div>
  )
}

export default Ptop